import styled, { css } from 'styled-components';
import { media, layout } from 'src/components/base';
import { CardMedia } from '@prisjakt/ui/card';

export const StyledArticle = styled.div`
  margin-bottom: ${layout.measurements.spacing300};
  flex: 1 0 100%;
  max-width: 100%;
  margin-right: 0;
  padding-right: 0;

  ${media.mediumUp`
    margin-right: ${layout.measurements.spacing100};
    padding-right: ${layout.measurements.spacing150};
    flex: 1 0 70%;
      max-width: 70%;
  `}
  ${media.largeUp`
    flex: 1 0 640px;
    max-width: 640px;
  `}
`;

interface IRelatedArticle {
  fullWidth: boolean;
}
export const RelatedArticleContainer = styled.section<IRelatedArticle>`
  flex: 1 0 100%;

  ${media.mediumUp`
    flex: 1;
  `}
  ${p =>
    p.fullWidth &&
    css`
      flex: 1 0 100%;
    `}
`;

export const StyledFeaturedArticle = styled.section`
  display: flex;
  flex-wrap: wrap;
  margin-bottom: ${layout.measurements.spacing300};
`;

export const RelatedArticleWrapper = styled.div`
  > * {
    margin-bottom: 1rem;
  }
`;

export const StyledCardMedia = styled(CardMedia)`
  min-height: 185px;
`;
